module.exports = __webpack_public_path__ + "img/tc.74f13122.svg";